const compactNumber = new Intl.NumberFormat("en", {
  notation: "compact",
  maximumFractionDigits: 1
});

export function formatCount(value: number) {
  return compactNumber.format(value);
}

export function formatBytes(size: number) {
  if (size < 1024) {
    return `${size} B`;
  }
  if (size < 1024 ** 2) {
    return `${(size / 1024).toFixed(1)} KB`;
  }
  return `${(size / 1024 ** 2).toFixed(1)} MB`;
}

export function errorMessage(error: unknown) {
  return Error.isError(error) ? error.message : String(error);
}
